import { css } from 'styled-components';
import { COLORS, METRICS } from '../../design/tokens';

const { FOOTER_CONTENT } = METRICS;

const styles = {
  nav: css`
    margin-bottom: 20px;
  `,
  rootContainer: css`
    flex: 1;
    width: 100%;
    padding: ${FOOTER_CONTENT.PADDING_TOP} ${FOOTER_CONTENT.PADDING_RIGHT} ${FOOTER_CONTENT.PADDING_BOTTOM} ${FOOTER_CONTENT.PADDING_LEFT};    
    background-color: ${COLORS.WHITE};
    
    .ui.link.list .item {
      color: ${COLORS.TEXT.LIGHT_GRAY};
      min-height: 16px;
      line-height: 24px;
    }
  `,
  listItem: css`
    display: flex;
    align-items: center;
    min-height: 30px;
    line-height: 24px;
    color: ${COLORS.TEXT.BLACK};
  `,
  col: css`
    padding: 0 0 0 5px;
  `,
  rowIcons: css`
    display: flex;
    > div {
      border: 1px solid ${COLORS.ICON.GRAY};
      border-radius: 2px;
      padding: 10px;
      margin-right: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 30px;
      min-width: 30px;
    }
  `,
  footerLink: css`
    padding-top: 3px;
    font-size: 14px;
    color: ${COLORS.TEXT.BLACK};
    line-height: 16px;
    
    svg {
      fill: ${COLORS.TEXT.BLACK}
    }
    
    &:hover svg {
      transition: fill 200ms ease-in-out;
      fill: ${COLORS.TEXT.SEA_BLUE}
    }
  `,
  colTitle: css`    
    height: 26px;
   
    span {
      letter-spacing: 0.8px;
      color: ${COLORS.TEXT.GRAY}
    }
  `
};

export default styles;
